import { Freelancer } from "../user";
import { DateTime } from "luxon";
import { IConverter, TSnapshot } from "./generics";

export const freelancerConverter: IConverter<Freelancer> = {
  toFirestore(freelancer: Freelancer) {
    return {
      ...freelancer,
      securityClearance: freelancer.securityClearance
        ? {
            ...freelancer.securityClearance,
            expirationDate:
              typeof freelancer.securityClearance.expirationDate === "string"
                ? freelancer.securityClearance.expirationDate
                : freelancer.securityClearance.expirationDate || null,
          }
        : undefined,
      employment: freelancer.employment
        ? {
            ...freelancer.employment,
            startDate:
              typeof freelancer.employment.startDate === "string"
                ? freelancer.employment.startDate
                : freelancer.employment.startDate || null,
          }
        : undefined,
      createdAt: freelancer.createdAt || new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
  },
  fromFirestore(snapshot: TSnapshot): Freelancer {
    const data = snapshot.data();
    return {
      id: snapshot.id,
      email: data.email || "",
      firstName: data.firstName || "",
      lastName: data.lastName || "",
      displayName: data.displayName || "",
      role: data.role || "freelancer",
      permissions: data.permissions || [],
      documents: data.documents || [],
      status: data.status,
      needsOnboarding: data.needsOnboarding,
      securityClearance: data.securityClearance
        ? {
            ...data.securityClearance,
            expirationDate: data.securityClearance.expirationDate
              ? DateTime.fromISO(data.securityClearance.expirationDate)
              : null,
          }
        : undefined,
      employment: data.employment
        ? {
            ...data.employment,
            startDate: data.employment.startDate
              ? DateTime.fromISO(data.employment.startDate)
              : null,
          }
        : undefined,
      disabled: data.disabled,
      lastLoginAt: data.lastLoginAt,
      lastPasswordResetRequestAt: data.lastPasswordResetRequestAt,
      needsPasswordReset: data.needsPasswordReset,
      passwordResetAt: data.passwordResetAt,
      onboardingCompletedAt: data.onboardingCompletedAt,
      createdAt: data.createdAt,
      updatedAt: data.updatedAt,
      needsInitialPasswordSet: data.needsInitialPasswordSet,
      initialPasswordSetAt: data.initialPasswordSetAt,
      lastVerificationEmailRequestAt: data.lastVerificationEmailRequestAt,
      lastSignInLinkRequestAt: data.lastSignInLinkRequestAt,

      // PAYMENT AND TAX PROFILE
      payrollProfileCompleted: data?.payrollProfileCompleted,
      payrollProfileCompletedAt: data?.payrollProfileCompletedAt,
      payrollProfileUpdatedAt: data?.payrollProfileUpdatedAt,

      // TAX FORM
      taxFormCompleted: data?.taxFormCompleted,
      taxFormDocumentHash: data?.taxFormDocumentHash,
      taxFormDocumentEmbedUrl: data?.taxFormDocumentEmbedUrl,
      taxFormGeneratedAt: data?.taxFormGeneratedAt,
      taxFormCompletedAt: data?.taxFormCompletedAt,
      taxFormNeedsUpdate: data?.taxFormNeedsUpdate,
      taxFormUpdatedAt: data?.taxFormUpdatedAt,
      taxFormVerifiedByAdmin: data?.taxFormVerifiedByAdmin,
      taxFormVerifiedByAdminAt: data?.taxFormVerifiedByAdminAt,
      newTaxFormRequested: data?.newTaxFormRequested,
      newTaxFormRequestedAt: data?.newTaxFormRequestedAt,
      newTaxFormRequestedByUserId: data?.newTaxFormRequestedByUserId,
      taxFormType: data?.taxFormType,
      oldTaxForms: data?.oldTaxForms,
      paymentAndTaxProfileVerifiedByUser:
        data?.paymentAndTaxProfileVerifiedByUser,
      paymentAndTaxProfileVerifiedByUserAt:
        data?.paymentAndTaxProfileVerifiedByUserAt,
      readyForPayroll: data?.readyForPayroll,
      readyForPayrollAt: data?.readyForPayrollAt,
      increaseExternalAccountProfile: data?.increaseExternalAccountProfile,
      directDepositAccountNeedsUpdate: data?.directDepositAccountNeedsUpdate,
      freelancerDocuments: data?.freelancerDocuments,
      meetingBaasCalendarUuid: data?.meetingBaasCalendarUuid,
      lastSignInIpAddress: data?.lastSignInIpAddress,
      notificationPreferences: data?.notificationPreferences,
      currentIndependentEngineerAgreementId:
        data?.currentIndependentEngineerAgreementId,
      profilePicture: data?.profilePicture,
    };
  },
};
